<template>
  <div class="avatar-picker">
    <label class="avatar-picker__upload">
      <button-app plain>{{ $t('CP.uploadImage') }}</button-app>
      <input ref="avatar" type="file" accept=".png, .jpg, .jpeg" @change="loadFile">
    </label>
    <p class="avatar-picker__caption form__description">{{ $t('CP.choosePredefinedAvatars') }}</p>
    <b-container class="avatar-picker__list">
      <b-row>
        <b-col v-for="avatar in list" :key="avatar" cols="3" sm="2" md="3" class="py-2"
          @click="selectPredefinedAvatar(avatar)">
          <img :src="avatar" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ButtonApp from '../../components/Button/ButtonApp';

export default {
  name: 'AvatarPicker',
  components: {
    ButtonApp,
  },
  props: {
    list: {
      type: Array,
    },
  },
  methods: {
    loadFile(event) {
      this.$emit('loadFile', event);
      this.$refs.avatar.value = null;
    },
    selectPredefinedAvatar(event) {
      this.$emit('loadFile', {
        avatar: event,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.avatar-picker {
  font-family: 'SF UI Display', Avenir, Helvetica, Arial, sans-serif;
  padding: 0 calc(32px - 1rem);
}
.avatar-picker__list {
  img {
    width: 100%;
    cursor: pointer;
  }
}
.avatar-picker__upload {
  display: block;
  position: relative;
  margin: 0;

  .btn-app {
    margin-top: 0;
    width: 100%;
  }
  input {
    height: 0;
    width: 0;
    opacity: 0;
    position: absolute;
    z-index: -1;
  }
}
.avatar-picker__caption {
  margin: 36px 0 24px;
  text-align: center;
}
</style>
